import { Component } from '@angular/core';
import { MatDialogModule, MatDialogRef } from '@angular/material/dialog';
import { MatButtonModule } from '@angular/material/button';

@Component({
  selector: 'app-dialog-restaurar-valores',
  standalone: true,
  imports: [MatButtonModule, MatDialogModule],
  templateUrl: './dialog-restaurar-valores.component.html',
  styleUrl: './dialog-restaurar-valores.component.scss',
})
export class DialogRestaurarValoresComponent {
  constructor(
    public dialogRef: MatDialogRef<DialogRestaurarValoresComponent>,
  ) {}
}
